import { Card } from "primereact/card";
import React, { ReactElement } from "react";
import styles from "./StatsCard.module.css";
import { StatsCardProps } from "../types/StatsCard";

import shipVessel from "../assets/StatsCardIcons/ShipVessel.svg";
import graph from "../assets/StatsCardIcons/Graph.svg";
import overdueCalendar from "../assets/StatsCardIcons/OverdueCalendar.svg";
import search from "../assets/StatsCardIcons/Search.svg";
import hardhat from "../assets/StatsCardIcons/Hardhat.svg";
import cogInHand from "../assets/StatsCardIcons/CogInHand.svg";
import cancel from "../assets/StatsCardIcons/Cancel.svg";
import hierarchy from "../assets/StatsCardIcons/Hierarchy.svg";
import horizontalBarChart from "../assets/StatsCardIcons/HorizontalBarGraph.svg";
import scatterGraph from "../assets/StatsCardIcons/ScatterGraph.svg";
import shipCrane from "../assets/StatsCardIcons/ShipCrane.svg";
import completedCalendar from "../assets/StatsCardIcons/CompletedCalendar.svg";

export const StatsCard = (props: StatsCardProps): ReactElement => {
    const header = () => (
        <div className="flex justify-content-between align-items-center">
            <div className="flex justify-content-left align-items-center pr-2">
                <strong
                    style={{ fontSize: props.statisticFontSize ?? "" }}
                    className={`${styles.statistic}`}
                >
                    {props.statistic}
                </strong>
                {props.statisticSubText && (
                    <small
                        className={`ml-2 align-items-center ${styles.statisticSubText}`}
                    >
                        {props.statisticSubText}
                    </small>
                )}
            </div>

            {HeaderIcon(props.icon)}
        </div>
    );

    const footer = () => (
        <div className="flex  justify-content-between">
            <span className={styles.statisticDetails}>
                {props.statisticDetails.toUpperCase()}
            </span>
        </div>
    );

    const cursorStyle = props.onClick ? "cursor-pointer" : "";

    return (
        <Card
            className={`h-full ${styles.statsCard} ${TileColor(
                props.color
            )} stats-card flex flex-column ${cursorStyle}`}
            header={header}
            footer={footer}
            data-testid="stats-card"
            onClick={() => {
                if (props.onClick) {
                    props.onClick(props);
                }
            }}
        >
            <span className={styles.statisticTitle}>
                {props.statisticTitle}
            </span>
        </Card>
    );
};

const HeaderIcon = (iconName: string) => {
    if (!iconName) {
        return <div />;
    }

    let icon;
    switch (iconName) {
        case "lowest-grade-vessel-icon":
            icon = shipVessel;
            break;
        case "overdue-inspection-icon":
            icon = overdueCalendar;
            break;
        case "average-grade-icon":
            icon = graph;
            break;
        case "inspections-due-icon":
            icon = search;
            break;
        case "worst-tech-manager-icon":
            icon = cogInHand;
            break;
        case "crew-welfare-icon":
            icon = hardhat;
            break;
        case "open-priority-defects-icon":
            icon = cancel;
            break;
        case "worst-class-society-icon":
            icon = hierarchy;
            break;
        case "worst-deviation-subgrade-icon":
            icon = horizontalBarChart;
            break;
        case "average-fleet-defects-icon":
            icon = scatterGraph;
            break;
        case "psc-performance-icon":
            icon = shipCrane;
            break;
        case "inspections-completed-icon":
            icon = completedCalendar;
            break;
        default:
            break;
    }

    return (
        <img
            data-testid="datacard-icon"
            src={icon}
            className={styles.headerIcon}
        ></img>
    );
};

const TileColor = (color: string) => {
    let tileColor;
    switch (color) {
        case "mid-blue":
            tileColor = styles.midBlue;
            break;
        case "light-blue":
            tileColor = styles.lightBlue;
            break;
        case "teal-blue":
            tileColor = styles.teal;
            break;
        case "purple":
            tileColor = styles.purple;
            break;
        default:
            tileColor = styles.midBlue;
            break;
    }

    return tileColor;
};
